module.exports = __webpack_public_path__ + "static/media/ms.094ad248.svg";